const rootActionPath = 'core/NearMeMapModal';

export const INSTORE_ALL_OFFERS_MAP_MODAL_TRIGGER = `${rootActionPath}/TRIGGER`;
export const INSTORE_ALL_OFFERS_MAP_MODAL_CLEAR = `${rootActionPath}/CLEAR`;
export const INSTORE_CURRENT_STORE_DATA = 'INSTORE_CURRENT_STORE_DATA';
